import React from "react"
import {Button, Grid, styled, Typography} from "@mui/material"
import { fileServerUrlParser } from "../../misc/utils"

export const widgetObjectListPrototype = [
        {
          "key": "objects",
          "type": "SELECTTREE",
          "label": "Objekte",
          "size": 6,
          "options": "objekte"
        }
      ]

export const LebensbausteinButton = styled(Button)(({theme}) => theme.LEBENSBAUSTEINBUTTON)

const WidgetObjectList = ({widget, triggerAction}) => {
    const items = widget.objects?.origin.children ?? []

    return (
        <Grid
            container
            spacing={5}
        >
            {items?.map((item) => (
                <Grid key={item.id} container size={3} spacing={2} wrap="nowrap">
                    <LebensbausteinButton
                        variant="primary"
                        key={item.id}
                        onClick={() =>
                            widget.action && triggerAction(widget.action, item)
                        }
                    >
                        <Grid container direction="column">
                            {item.icon && <img src={fileServerUrlParser(item.icon)} alt="Lebensbaustein-Icon"/>}
                            <Typography textAlign="center" fontSize="14px" color="#072ECA">
                                {item.longname}
                            </Typography>
                        </Grid>
                    </LebensbausteinButton>
                    <Typography mt={0.5}>{item.description}</Typography>
                </Grid>
            ))}
        </Grid>
    )
}

export default WidgetObjectList
